export default "__VITE_ASSET__CdGFGjYW__"